import React from "react";

import { ToggleSwitch } from "../../../comps/toggle-switch";
import { ls } from "../../../locale";
import clsx from "clsx";
import { PriceBox } from "./PriceBox";
import { ServiceListItem } from "../helpers";

type AirportServiceProps = {
  hasItems: boolean;
  services: ServiceListItem[];
  onSelectService: (logicalFlightId: number, ssrCode: string) => void;
  onClearService: (logicalFlightId: number, ssrCode: string) => void;
  onToggle: (checked: boolean) => void;
  resourceKey: string;
  icon: string;
};


export function AirportService({ hasItems, services, onSelectService, onClearService, onToggle, resourceKey, icon }: AirportServiceProps) {

  if (!Array.isArray(services) || services.length === 0) return null;

  return (
    <div className="tw-mt-4 tw-mb-10">
      <div className='tw-mt-5 tw-shadow-outline-gray tw-bg-white'>
        <div className="tw-mb-0 tw-min-h-[125px]">
          <Header resourceKey={resourceKey} icon={icon} hasItems={hasItems} onToggle={onToggle} />
        </div>
        {hasItems && (
          <div className='tw-flex tw-flex-col tw-gap-0'>
            {services.map((item, index) => (
              <ServiceBox key={index} item={item} onSelectService={onSelectService} onClearService={onClearService} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function Header({
  resourceKey,
  icon,
  hasItems,
  onToggle
}: {
  resourceKey: string,
  icon: string,
  hasItems: boolean,
  onToggle: (checked: boolean) => void
}) {

  const rLounge = ls.t(resourceKey);

  const handleHeaderClick = () => {
    if (!hasItems) onToggle(true);
  };

  return (
    <div className='tw-p-4 tw-flex tw-flex-row tw-gap-1 tw-cursor-pointer' onClick={handleHeaderClick}>
      <div className="">
        <img src={icon} alt={rLounge.Label} className="tw-size-20" />
      </div>
      <div className="tw-flex-1 tw-flex tw-flex-col tw-ps-1 tw-justify-between">
        <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
          <div className='tw-text-lg sa-text-green tw-uppercase'>{rLounge.Label}</div>
          <div className="tw-px-2" onClick={e => e.stopPropagation()}>
            <ToggleSwitch checked={hasItems} onChange={onToggle} />
          </div>
        </div>
        <div>
          {rLounge.Terms}
        </div>
      </div>
    </div>
  );
}

function ServiceBox({
  item,
  onSelectService,
  onClearService
}: {
  item: ServiceListItem,
  onSelectService: (logicalFlightId: number, ssrCode: string) => void,
  onClearService: (logicalFlightId: number, ssrCode: string) => void
}) {

  const service = item.service;
  if (!service) return null;

  const handleServiceClick = () => {
    const select = service.selected;
    if (select) {
      if (typeof onClearService === 'function') {
        onClearService(item.logicalFlightId, service.ssrCode);
      }
      return
    }

    if (typeof onSelectService === 'function') {
      onSelectService(item.logicalFlightId, service.ssrCode);
    }
  }

  return (
    <div className={clsx('tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between',
      'tw-border tw-border-solid tw-border-gray-200'
    )}>
      <div className='tw-p-6 md:tw-px-4 tw-flex tw-flex-row tw-items-center'>
        <span className="tw-hidden md:tw-block tw-me-2 tw-font-bold">{service.description}</span>
        <span>{service.label}</span>
      </div>
      <PriceBox
        service={service}
        selected={service.selected}
        included={service.included}
        purchased={service.purchased}
        currencyCode={item.currencyCode}
        hideDescription={true}
        onClick={handleServiceClick}
      />
    </div>
  )
}
